<div class="advantage-item">
  <img class="mb-12" [src]="imageLink" alt="">
  <div class="typography typography-headline typography-bold mb-8 advantage-item-title" [innerHTML]="title"></div>
  <div class="typography typography-headline advantage-item-description" [innerHTML]="description"></div>
</div>
